import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const GTA_CENTER = [43.7417, -79.3733];

export const ServiceAreaMap = ({ height = 400 }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;
    const map = L.map(containerRef.current, {
      center: GTA_CENTER,
      zoom: 8,
      scrollWheelZoom: false,
      attributionControl: false,
    });
    mapRef.current = map;
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      subdomains: 'abcd', maxZoom: 19,
    }).addTo(map);
    const gold = '#D4AF37';
    const icon = L.divIcon({
      className: '',
      html: `<div style="width:16px;height:16px;border-radius:50%;background:${gold};border:3px solid #0f0f10;box-shadow:0 0 12px ${gold}88;"></div>`,
      iconSize: [16, 16],
      iconAnchor: [8, 8],
    });
    L.marker(GTA_CENTER, { icon }).addTo(map).bindPopup('<b>Dream Room Theaters</b><br/>Greater Toronto Area');
    [50000, 150000, 300000].forEach((radius, i) => {
      L.circle(GTA_CENTER, {
        radius, color: gold, weight: 1, opacity: 0.5 - i * 0.12,
        fillColor: gold, fillOpacity: 0.05 - i * 0.012,
      }).addTo(map);
    });
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{ height }}
      className="rounded-sm overflow-hidden border border-white/10 z-0"
      data-testid="service-area-map"
    />
  );
};
